module.exports = __webpack_public_path__ + "img/trueIcon.97a2d9d2.svg";